export default __webpack_public_path__ + "static/media/AccordionMobile.080c5328.png";